
$(function() {
	initMobileMenuOpen();
	initArtistStudioSlider();
});
/* ---------------------------------------------------------------------------------------------
 SP版 ハンバーガーメニュー内のアコーディオン
 「オンラインストア > シーン別」「オンラインストア > 全商品・ギフト」を冒頭で開いた状態にする
--------------------------------------------------------------------------------------------- */
//メニューがアプリのJSによって動的に生成されるため、初期処理が終わるのをobserverで監視して待つ
function initMobileMenuOpen(){
	//observerでクラスの変化を監視
	//const target = document.querySelector(".mobile-nav");
    const target = document.querySelector(".slide-nav");
	const observer = new MutationObserver(records => {
    	if(target.classList.contains("tmenu_initialized")){
        	click_SearchArt();
        	observer.disconnect();
        } 
	});
	observer.observe(target, {
		attributes: true,
		attributeFilter: ['class']
	});
}
//サブメニューがアコーディオンの開くボタンを押してから動的に生成されるため、生成されるのをobserverで監視して待つ
let tmenu_item0;
function click_SearchArt(){
	//observerで子要素の変化を監視
	const tmenu_items = document.querySelectorAll('.slide-nav > .tmenu_item');
	tmenu_item0 = tmenu_items[0];
	const observer = new MutationObserver(records => {
    	if(tmenu_item0.querySelector('.tmenu_item_level_1')){
        	click_searchCategory();
        	observer.disconnect();
        } 
	});
	observer.observe(tmenu_item0, {
		childList: true
	});
	//アコーディオンの開くボタンをJSでクリック
	const a = tmenu_item0.firstElementChild;
	a.click();
}
//第二階層のアコーディオンの開くボタンをJSでクリック
function click_searchCategory(){
	//カテゴリーから探す
	const tmenu_item_level_1_1 = tmenu_item0.getElementsByClassName('tmenu_item_level_1')[0];
	const a2_1 = tmenu_item_level_1_1.firstElementChild;
	a2_1.click();
	//飾りたい場所から探す
	const tmenu_item_level_1_2 = tmenu_item_level_1_1.nextElementSibling;
	const a2_2 = tmenu_item_level_1_2.firstElementChild;
	a2_2.click();
}
/* ---------------------------------------------------------------------------------------------
 initArtistStudioSlider：アーティスト詳細ページのアートスタジオスライダー
--------------------------------------------------------------------------------------------- */
let artstudioSlider;
function initArtistStudioSlider(){
	const el = document.getElementById('artStudioSlider');
	if(el){
		const args = {
			//adaptiveHeight: true,
			// autoPlay: false,
			// avoidReflow: false, // custom by Archetype
			// childNav: null, // element. Custom by Archetype instead of asNavFor
			// childNavScroller: null, // element
			// childVertical: false,
			// fade: false,
			// initialIndex: 0,
			pageDots: true,
			// pauseAutoPlayOnHover: false,
			// prevNextButtons: false,
			// rightToLeft: theme.config.rtl,
			// setGallerySize: true,
			// wrapAround: true,
			// resize: true
		};
		artstudioSlider = new Flickity(el,args);
		
		window.onresize = function(){
			artstudioSlider.resize();
		}	
	}

}
